import { FC, useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import { toast } from "react-toastify";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon from "../../assets/marker.png";
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrosshairs } from "@fortawesome/free-solid-svg-icons";

const Map = () => {
  const params = useParams();
  let location: any = useLocation();
  const navigate = useNavigate();
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const mapContainerRef = useRef(null);
  const [latitude, setLatitude] = useState<any>("");
  const [longitude, setLongitude] = useState<any>("");
  const [loc, setLocation] = useState({
    latitude: -6.2088,
    longitude: 106.8456,
  });

  const myIcon = L.icon({
    iconUrl: markerIcon,
    iconSize: [82, 82],
    iconAnchor: [16, 32],
  });

  const handleLocateUser = async () => {
    try {
      if (loc.latitude && loc.longitude) {
        if (mapRef.current && markerRef.current) {
          mapRef.current.setMaxZoom(21);
          mapRef.current.setView([loc.latitude, loc.longitude], 21);
          markerRef.current.setLatLng([loc.latitude, loc.longitude]);
        }
        setLatitude(loc.latitude);
        setLongitude(loc.longitude);
      } else {
        toast.warn("Lokasi tidak tersedia, aktifkan lokasi anda");
        navigate("/home");

        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const lat = pos.coords.latitude;
            const lng = pos.coords.longitude;
            setLatitude(lat);
            setLongitude(lng);
            setLocation({ latitude: lat, longitude: lng });

            if (mapRef.current && markerRef.current) {
              mapRef.current.setMaxZoom(21);
              mapRef.current.setView([lat, lng], 21);
              markerRef.current.setLatLng([lat, lng]);
            }
          },
          (err) => {
            // console.error("Geolocation error:", err);
            toast.error("Izin lokasi ditolak");
          }
        );
      }
    } catch (error) {
      // console.error("Locate user error:", error);
      toast.error("Geolocation failed");
    }
  };

  useEffect(() => {
    const parsedLat = parseFloat(params.lat as string);
    const parsedLon = parseFloat(params.lon as string);

    if (!isNaN(parsedLat) && !isNaN(parsedLon)) {
      setLatitude(parsedLat);
      setLongitude(parsedLon);
      setLocation({
        latitude: parsedLat,
        longitude: parsedLon,
      });
    } else {
      toast.error("Lokasi tidak tersedia, aktifkan izin lokasi");
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos.coords.latitude;
          const lng = pos.coords.longitude;
          setLatitude(lat);
          setLongitude(lng);
          setLocation({ latitude: lat, longitude: lng });
        },
        (err) => {
          console.error("Geolocation error:", err);
          navigate("/home");
        }
      );
    }
  }, [params.lat, params.lon, navigate]);

  useEffect(() => {
    if (!mapContainerRef.current) return;

    const { latitude, longitude } = loc;

    mapRef.current = L.map(mapContainerRef.current, {
      center: [latitude, longitude],
      zoom: 19,
      maxZoom: 21,
      minZoom: 2,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      boxZoom: false,
      keyboard: false,
      touchZoom: true,
      zoomControl: false,
    });

    // custom control (locate button)
    const locateControl = L.control({ position: "bottomright" });
    locateControl.onAdd = function () {
      const div = L.DomUtil.create(
        "div",
        "leaflet-bar leaflet-control leaflet-control-custom"
      );

      // styling
      div.style.width = "40px";
      div.style.height = "40px";
      div.style.cursor = "pointer";
      div.style.backgroundColor = "#fff";
      div.style.borderRadius = "50%";
      div.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
      div.style.display = "flex";
      div.style.alignItems = "center";
      div.style.justifyContent = "center";

      div.style.marginBottom = "50px";
      div.style.marginRight = "10px";

      const root = ReactDOM.createRoot(div);
      root.render(
        <button
          title="Lokasi saya"
          aria-label="Lokasi saya"
          onClick={handleLocateUser}
          style={{
            all: "unset",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FontAwesomeIcon icon={faCrosshairs} fontSize={18} />
        </button>
      );

      return div;
    };
    locateControl.addTo(mapRef.current);

    // tile layer
    L.tileLayer(
      "https://{s}.google.com/vt/lyrs=m@221097413,traffic&x={x}&y={y}&z={z}",
      {
        maxZoom: 21,
        minZoom: 2,
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
      }
    ).addTo(mapRef.current);

    // add marker
    markerRef.current = L.marker([latitude, longitude], {
      draggable: false,
      icon: myIcon,
    }).addTo(mapRef.current);

    // show default popup if fallback
    if (latitude === -6.2088 && longitude === 106.8456) {
      L.popup()
        .setLatLng([latitude, longitude])
        .setContent("Geolocation failed. Defaulting to Jakarta.")
        .openOn(mapRef.current);
    }

    return () => {
      mapRef.current?.remove();
    };
  }, [loc]);
  return (
    <>
      <div className="">
        <div
          ref={mapContainerRef}
          id="map"
          style={{ height: "90vh", width: "100%" }}
        ></div>
      </div>
      <div className="bar fixed z-[9999] bottom-0 w-full bg-white px-4 py-5">
        <button
          className={
            "text-center active:bg-zinc-100 rounded-md border border-transparent bg-green-300 px-5 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 w-full"
          }
          onClick={() => {
            if (params.action === "checkin") {
              navigate(`/home/checkin/${params.shiftId}`);
            } else if (params.action === "checkout-selfie") {
              navigate(`/home/selfie-checkout`);
            } else if (params.action === "checkout") {
              navigate(`/home/checkout`);
            }
          }}
        >
          {"Lanjutkan"}
        </button>
      </div>
    </>
  );
};

export default Map;
